export const SEED_FARM_TYPE_BIN_FEN = '缤纷';
export const SEED_FARM_TYPE_EXTERNAL = '外部';

export const formatSeedFarmType = userType => {
    switch (userType) {
        case SEED_FARM_TYPE_BIN_FEN:
            return '缤纷';
        case SEED_FARM_TYPE_EXTERNAL:
            return '外部';
        default:
            return '';
    }
};
